(function () {
  "use strict";

  function fire(name, detail) {
    if (window.Prarvi && typeof window.Prarvi.track === "function") {
      window.Prarvi.track(name, detail);
      return;
    }
    try {
      window.dispatchEvent(new CustomEvent("prarvi:" + name, { detail: detail || {} }));
    } catch (e) {}
  }

  function initSection(section) {
    if (!section || section.getAttribute("data-video-promo-ready") === "1") return;
    section.setAttribute("data-video-promo-ready", "1");

    var video = section.querySelector("[data-video-promo-video]");
    var playButton = section.querySelector("[data-video-promo-play]");
    var sectionId = section.getAttribute("data-section-id") || "";
    var viewed = false;
    var completed = false;
    var sourceLoaded = false;

    function detail(extra) {
      var payload = {
        section_id: sectionId,
        placement: section.getAttribute("data-placement") || "unknown"
      };
      if (extra) {
        Object.keys(extra).forEach(function (key) { payload[key] = extra[key]; });
      }
      return payload;
    }

    function loadVideoSource() {
      if (!video || sourceLoaded) return;
      sourceLoaded = true;
      video.querySelectorAll("source[data-src]").forEach(function (source) {
        source.setAttribute("src", source.getAttribute("data-src"));
        source.removeAttribute("data-src");
      });
      video.load();
    }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!viewed && entry.isIntersecting) {
            viewed = true;
            fire("video_promo_view", detail());
          }
          if (video && entry.isIntersecting && entry.intersectionRatio >= 0.45) {
            loadVideoSource();
            if (video.getAttribute("data-video-promo-autoplay") === "true") {
              video.play().catch(function () {
                section.classList.remove("ad-video-promo--playing");
              });
            }
            observer.disconnect();
          }
        });
      }, { threshold: [0.35, 0.45] });
      observer.observe(section);
    } else {
      fire("video_promo_view", detail());
      loadVideoSource();
    }

    if (video) {
      video.addEventListener("play", function () {
        section.classList.add("ad-video-promo--playing");
        fire("video_promo_play", detail());
      });
      video.addEventListener("pause", function () {
        if (!video.ended) section.classList.remove("ad-video-promo--playing");
        if (!video.ended) fire("video_promo_pause", detail({ current_time: Math.round(video.currentTime || 0) }));
      });
      video.addEventListener("ended", function () {
        section.classList.remove("ad-video-promo--playing");
        if (!completed) {
          completed = true;
          fire("video_promo_complete", detail());
        }
      });
      if (!("IntersectionObserver" in window) && video.getAttribute("data-video-promo-autoplay") === "true") {
        video.play().catch(function () {
          section.classList.remove("ad-video-promo--playing");
        });
      }
    }

    if (playButton && video) {
      playButton.addEventListener("click", function () {
        loadVideoSource();
        section.classList.add("ad-video-promo--playing");
        video.setAttribute("controls", "controls");
        video.play().catch(function () {});
      });
    }

    // CTA click tracking is handled by prarvi-analytics.js's global
    // data-prarvi-event delegate. Avoid a local listener here so the
    // event isn't fired twice per click (P0-015).
  }

  function init() {
    document.querySelectorAll("[data-video-promo]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
